export default "__VITE_ASSET__CY8CTHdn__"